import { render, staticRenderFns } from "./AppLogin.vue?vue&type=template&id=0b96d8b6&scoped=true&"
import script from "./AppLogin.js?vue&type=script&lang=js&"
export * from "./AppLogin.js?vue&type=script&lang=js&"
import style0 from "./style.css?vue&type=style&index=0&id=0b96d8b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b96d8b6",
  null
  
)

export default component.exports